exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.monitor-yt-popover {\r\n  background: #edf5ff;\r\n  border: 1px solid #97c3ff;\r\n  padding: 13px 15px 6px 15px;\n}\r\n", ""]);

// exports
